<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    :nudge-width="320"
    offset-y
  >
    <template #activator="{ on: onMenu, attrs: attrsMenu }">
      <avs-button
        v-on="{ ...onMenu }"
        v-bind="{ ...attrsMenu }"
        fab
        iconI="mdi-folder-plus-outline"
        icon
        label
        small
        color="secondary"
        :spantext="$t('actions.create', { entity: $tc('commons.folder', 1).toLowerCase() })"
      >
      </avs-button>
    </template>

    <avs-card noTitle>
      <template v-slot:content>
        <v-form
          ref="mkDirForm"
          v-model="isMkDirFormValid"
        >
          <v-card-text>
            <v-text-field
              v-model="dirname"
              :rules="rules"
              @keyup.native.enter="mkdir"
              clearable
              :label="$t('commons.name')"
              outlined
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-space-around">
            <avs-createButton
              noSpantext
              :name="$t('commons.create')"
              @click.stop="mkdir"
            />
            <avs-cancelButton @click="initialize" />
          </v-card-actions>
        </v-form>
      </template>
    </avs-card>
  </v-menu>
</template>

<script>
import DocumentationService from "@/services/DocumentationService"
//import { capitalize } from "@/utils/string"
import { required } from "@/utils/validator"

export default {
  name: "MenuMkDir",
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  data() {
    return {
      isOpen: false,
      dirname: "",
      rules: [required],
      isMkDirFormValid: false
    }
  },
  props: {
    folder: {
      type: Object
    },
    isLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mkdir() {
      if (this.$refs.mkDirForm.validate()) {
        if (this.folder) {
          this.dirname = this.folder.name + "/" + this.dirname
        }
        let directory = this.dirname //capitalize(this.dirname)
        DocumentationService.createFolder(this, this.projectId, { name: directory }).then(
          response => {
            this.$emit("created", response)
            this.initialize()
          }
        )
      }
    },
    initialize() {
      this.dirname = ""
      this.isOpen = false
    }
  }
}
</script>
